import styled from 'styled-components';

export const BaseWidgetActionsContainer = styled.div`
  display: none;
  flex-wrap: nowrap;
  gap: 8px;
  align-items: center;

  &[data-is-always-visible='true'] {
    display: flex;
  }
`;
